module.exports = __webpack_public_path__ + "img/green-circle-check.6edbc238.svg";